export enum ConfirmCodeSendType {
	disable = 1,
	SMS = 2,
	Email = 3,
	TwoFactorAuthentication = 4
}
